export default __webpack_public_path__ + "static/media/icon-print.21a7a831.svg";